module.exports = __webpack_public_path__ + "img/exodus-logo.40fdc906.webp";